import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTranslations } from "next-intl";
import { ThemeProvider } from "@emotion/react";
import { BenefitsLegacy, ContentArticle, RentalCompaniesLegacy, StageLegacy } from "@silvertours/front-features";
import { Theme } from "@silvertours/front-shared";
import { Body } from "../body";
var SupplierRatingsContent = function(_param) {
    var _content = _param.content, article = _content.article, globalRating = _content.globalRating, introduction = _content.introduction, links = _content.links, stage = _content.stage, primaryHeadline = _content.textContent.primaryHeadline, commonProps = _object_without_properties(_param, [
        "content"
    ]);
    var t = useTranslations("features");
    var translations = t.raw("article");
    var ref, _content1;
    return /*#__PURE__*/ _jsx(Body, _object_spread({
        title: primaryHeadline,
        stage: /*#__PURE__*/ _jsx(StageLegacy.Stage, {
            content: stage.content
        }),
        content: function(param) {
            var containerModule = param.containerModule;
            return [
                containerModule("usp", /*#__PURE__*/ _jsx(BenefitsLegacy.Usp, {
                    rating: globalRating.content
                })),
                containerModule("introduction-content", /*#__PURE__*/ _jsx(ThemeProvider, {
                    theme: Theme.defaultTheme,
                    children: /*#__PURE__*/ _jsx(ContentArticle, {
                        modules: (ref = introduction === null || introduction === void 0 ? void 0 : introduction.segments) !== null && ref !== void 0 ? ref : [],
                        translations: translations
                    })
                }), !!(introduction === null || introduction === void 0 ? void 0 : introduction.segments)),
                containerModule("rental-companies-links", /*#__PURE__*/ _jsx(RentalCompaniesLegacy.RentalCompaniesLinks, {})),
                containerModule("article", /*#__PURE__*/ _jsx(ThemeProvider, {
                    theme: Theme.defaultTheme,
                    children: /*#__PURE__*/ _jsx(ContentArticle, {
                        modules: article.segments,
                        translations: translations
                    })
                })),
                containerModule("linkLists", /*#__PURE__*/ _jsx(ThemeProvider, {
                    theme: Theme.defaultTheme,
                    children: /*#__PURE__*/ _jsx(ContentArticle, {
                        modules: (_content1 = links.content) !== null && _content1 !== void 0 ? _content1 : [],
                        translations: translations
                    })
                }), !!links.content.length), 
            ];
        }
    }, commonProps));
};
export { SupplierRatingsContent };
